export default "__VITE_ASSET__CNxzYWpR__"